"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mana = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var network_1 = require("@dcl/schemas/dist/dapps/network");
var Header_1 = require("../Header/Header");
var Popup_1 = require("../Popup/Popup");
require("./Mana.css");
var Mana = /** @class */ (function (_super) {
    __extends(Mana, _super);
    function Mana() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Mana.prototype.render = function () {
        var _a = this.props, size = _a.size, className = _a.className, inline = _a.inline, children = _a.children, network = _a.network, primary = _a.primary, showTooltip = _a.showTooltip, rest = __rest(_a, ["size", "className", "inline", "children", "network", "primary", "showTooltip"]);
        var ManaInner = (React.createElement(Header_1.Header, __assign({ size: size, className: (0, classnames_1.default)('dcl', 'mana', inline ? 'inline ' : null, className) }, rest),
            React.createElement("i", { className: "symbol" },
                React.createElement("i", { className: (0, classnames_1.default)(network.toLowerCase(), primary ? 'primary' : null) })),
            children));
        if (showTooltip) {
            return (React.createElement(Popup_1.Popup, { position: "top center", content: "".concat(network, " MANA"), trigger: ManaInner, basic: true }));
        }
        return ManaInner;
    };
    Mana.defaultProps = {
        className: '',
        network: network_1.Network.ETHEREUM,
        primary: false
    };
    return Mana;
}(React.Component));
exports.Mana = Mana;
